import React, { useState } from 'react';
import { Box, CardActionArea, CircularProgress } from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

import ConfirmDialog from '../ConfirmDialog';
import AddUserDialog from '../Add';
import { UserModel } from '../../../types/User';
import { bulkRemove, deleteUser } from '../../../apis/user';
import SearchComponent from '../Search';
import BulkCreateError from '../Add/Result';
import './action.scss';

interface ActionHeaderProps {
  userSelected: number[];
  getAllUsers: () => void;
  users: UserModel[];
  setUserSelected: ([]) => void;
}
const ActionHeader: React.FC<ActionHeaderProps> = (props) => {
  const { userSelected, setUserSelected, getAllUsers, users } = props;
  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [errData, setErrData] = useState<any>(null);

  const [selectUser, setSelectUser] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const findAndSelectUser = (id: number) =>
    setSelectUser(users.filter((user: UserModel) => user.id === id)[0]);

  const onClickDeleteUser = () => {
    setLoading(true);
    setOpenConfirmDialog(false);

    if (userSelected.length === 1) {
      deleteUser(userSelected[0])
        .then(() => {
          setUserSelected([]);
          getAllUsers();
        })
        .finally(() => setLoading(false));
    } else {
      bulkRemove(userSelected)
        .then(() => {
          setUserSelected([]);
          getAllUsers();
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <>
      <Box className='mainHeader'>
        <SearchComponent getAllUsers={getAllUsers} />

        <Box className='flexCenter' gap={1}>
          <CardActionArea className='actionBox' onClick={() => setOpenAddUserDialog(true)}>
            <AddRoundedIcon color='secondary' />
          </CardActionArea>

          <CardActionArea
            disabled={userSelected.length !== 1}
            className='actionBox'
            onClick={() => {
              findAndSelectUser(userSelected[0]);
              setOpenAddUserDialog(true);
            }}
          >
            <BorderColorRoundedIcon color='secondary' />
          </CardActionArea>

          <CardActionArea
            disabled={userSelected.length === 0 || loading}
            className='actionBox'
            onClick={() => setOpenConfirmDialog(true)}
          >
            {loading ? (
              <Box p={0.4} className='flexCenter'>
                <CircularProgress size={15} color='primary' />
              </Box>
            ) : (
              <DeleteOutlineRoundedIcon color='secondary' />
            )}
          </CardActionArea>

          <CardActionArea className='actionBox' onClick={() => getAllUsers()}>
            <RefreshRoundedIcon color='secondary' />
          </CardActionArea>
        </Box>
      </Box>

      <ConfirmDialog
        openConfirmDialog={openConfirmDialog}
        closeDialog={() => setOpenConfirmDialog(false)}
        onSubmit={onClickDeleteUser}
        title='حذف کردن کاربر'
        description={`آیا از حذف ${userSelected.length} کاربر انتخاب شده مطمئن هستید؟`}
      />

      <AddUserDialog
        openAddUserDialog={openAddUserDialog}
        closeDialog={() => {
          setOpenAddUserDialog(false);
          if (selectUser) setSelectUser(null);
        }}
        getAllUsers={getAllUsers}
        selectUser={selectUser}
        setErrData={setErrData}
      />

      <BulkCreateError
        openBulkCreateError={!!errData}
        closeDialog={() => setErrData(null)}
        errData={errData}
      />
    </>
  );
};

export default ActionHeader;
